import Empreendimento from "./Empreendimento";

export default Empreendimento;
